import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Modal, Button, Dropdown } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaArrowRight, FaArrowLeft, FaCertificate, FaEllipsisV } from 'react-icons/fa';
import Select from 'react-select';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';

const Liste_Specialite = ({ titre }) => {
    useAuth();
    const [specialites, setSpecialites] = useState([]);
    const [selectedSpecialite, setSelectedSpecialite] = useState(null);
    const [specialiteToEdit, setSpecialiteToEdit] = useState(null);
    const [specialiteToDelete, setSpecialiteToDelete] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'titre', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [nouvSpecialite, setNouvSpecialite] = useState({
        titre: '',
        tag: [],
    });
    const [modifSpecialite, setModifSpecialite] = useState({
        titre: '',
        tag: [],
    });
    const [tags, setTags] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(false);

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Formatage des options pour react-select
    const tagOptions = tags.map(tag => ({
        value: tag.titre,
        label: tag.titre
    }));

    // Mise à jour du titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Spécialités";
        }
    }, [user_id]);

    const fetchSpecialites = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');
            const url = `${process.env.REACT_APP_HOTE}/liste-specialite/?page=${currentPage}&per_page=${itemsPerPage}&search=${searchTerm}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                const data = await response.json();
                setSpecialites(data.liste_spe || []);
                setTotalItems(data.total || 0);
                setHasMore(data.has_more || false);
            } else {
                console.error('Erreur lors de la récupération des spécialités');
                setSpecialites([]);
                setTotalItems(0);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setSpecialites([]);
            setTotalItems(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSpecialites();
    }, [currentPage, itemsPerPage, searchTerm]);

    // Récupération des tags
    useEffect(() => {
        const fetchTags = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-tag/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setTags(data);
                } else {
                    console.error('Erreur lors de la récupération des tags');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchTags();
    }, []);

    // Gestion des alertes
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    }

    const handleRowClick = (specialite) => {
        setSelectedSpecialite(specialite);
    };

    // Tri des spécialités
    const sortedSpecialites = [...specialites].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Gestion des modals
    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setNouvSpecialite({ titre: '', tag: [] });
    };

    const handleShowEditModal = (specialite) => {
        setSpecialiteToEdit(specialite);
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSpecialiteToEdit(null);
        setModifSpecialite({ titre: '', tag: [] });
    };

    const handleShowDeleteModal = (specialite) => {
        setSpecialiteToDelete(specialite);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSpecialiteToDelete(null);
    };

    // Ajout d'une spécialité
    const handleEnregSpecialite = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const specialiteData = {
                ...nouvSpecialite,
                user_id: user_id
            };
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-specialite/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(specialiteData),
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Spécialité ajoutée avec succès:', result);
                handleCloseAddModal();
                fetchSpecialites();
                showAlert("Spécialité ajoutée avec succès !");
                setNouvSpecialite({ titre: '', tag: [] });
                fermerNotif()
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlertModal((errorData.error || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlertModal('Erreur de connexion au serveur. Veuillez réessayer plus tard.', 'danger');
        }
    };

    // Modification d'une spécialité
    const handleModifierSpecialite = async (event) => {
        event.preventDefault();
        if (!specialiteToEdit) return;

        try {
            const token = localStorage.getItem('access_token');
            const specialiteModifData = {
                ...specialiteToEdit,
                user_id: user_id
            };
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-specialite/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(specialiteModifData),
            });

            if (response.ok) {
                handleCloseEditModal();
                fetchSpecialites();
                showAlert("Spécialité modifiée avec succès !");
                fermerNotif()
            } else {
                const errorData = await response.json();
                showAlertModal((errorData.error || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
            showAlertModal('Erreur de connexion au serveur.', 'danger');
        }
    };

    // Suppression d'une spécialité
    const handleDeleteSpecialite = async () => {
        if (!specialiteToDelete) return;

        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-specialite/${specialiteToDelete.id}/${user_id}/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                setShowDeleteModal(false);
                fetchSpecialites();
                showAlert("Spécialité supprimée avec succès !");
                setSpecialiteToDelete(null);
                if (selectedSpecialite?.id === specialiteToDelete.id) {
                    setSelectedSpecialite(null);
                }
                fermerNotif()
            } else {
                console.error('Erreur lors de la suppression de la spécialité');
                showAlertModal('Erreur lors de la suppression de la spécialité', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlertModal('Erreur de connexion au serveur.', 'danger');
        }
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaCertificate size={25} className='mr-2' />
                                Gestion des spécialités
                            </h2>
                            <small>Administration des spécialités de formation.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-specialite`}>Spécialités</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des spécialités</h5>
                                <div>
                                    <button onClick={handleShowAddModal} className="btn btn-success ms-2 mr-2 mt-1">
                                        <FaPlus /> Ajouter
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type === 'danger' ? 'danger' : 'success'} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ message: '', type: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher par titre..."
                                                    className="form-control"
                                                    style={{ maxWidth: '250px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>

                                            <div className="table-" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '200px', cursor: 'pointer' }} onClick={() => handleSort('titre')}>
                                                                Titre {sortConfig.key === 'titre' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '250px', cursor: 'pointer' }} onClick={() => handleSort('tag')}>
                                                                Tags {sortConfig.key === 'tag' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '150px', cursor: 'pointer' }} onClick={() => handleSort('date_creation')}>
                                                                Date de création
                                                            </th>
                                                            <th className='text-secondary text-wrap' style={{ minWidth: '80px', textAlign: 'center' }}>
                                                                Actions
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {sortedSpecialites.length > 0 ? sortedSpecialites.map((specialite) => (
                                                                <tr
                                                                    key={specialite.id}
                                                                    className={`bg-white ${selectedSpecialite && selectedSpecialite?.id === specialite.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(specialite)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <td>
                                                                        {specialite.titre}
                                                                        <div className='lesInfos d-md-none'>
                                                                            <small>Tags : </small>
                                                                            <div className="d-flex flex-wrap mt-1">
                                                                                {specialite.tag && specialite.tag.length > 0 ? (
                                                                                    specialite.tag.map((tag, idx) => (
                                                                                        <span key={idx} className="badge bg-success me-1 mb-1">
                                                                                            {tag}
                                                                                        </span>
                                                                                    ))
                                                                                ) : 'Aucun tag'}
                                                                            </div>
                                                                            <small>Créée le : {specialite.date_creation ? new Date(specialite.date_creation).toLocaleDateString() : 'N/A'}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        <div className="d-flex flex-wrap">
                                                                            {specialite.tag && specialite.tag.length > 0 ? (
                                                                                specialite.tag.map((tag, idx) => (
                                                                                    <span className="badge bg-success mr-1 mb-1">
                                                                                        {tag}
                                                                                    </span>
                                                                                ))
                                                                            ) : (
                                                                                <span className="text-muted">Aucun tag</span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {specialite.date_creation ? new Date(specialite.date_creation).toLocaleDateString() : 'N/A'}
                                                                    </td>
                                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle variant="light" size="sm" className="bg-transparent border-0">
                                                                                <FaEllipsisV />
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item
                                                                                    onClick={() => handleShowEditModal(specialite)}
                                                                                >
                                                                                    <FaEdit className="me-2 text-primary" />
                                                                                    Modifier
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item
                                                                                    onClick={() => handleShowDeleteModal(specialite)}
                                                                                    className="text-danger"
                                                                                >
                                                                                    <FaTrash className="me-2 text-danger" />
                                                                                    Supprimer
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">Aucune spécialité disponible</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="4" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${((currentPage - 1) * itemsPerPage) + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }
                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal d'ajout avec react-select */}
                    <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg">
                        <Modal.Header>
                            <Modal.Title>Ajouter une spécialité</Modal.Title>
                        </Modal.Header>

                        {alertModal.message && (
                            <div className={`alert alert-${alertModal.type === 'danger' ? 'danger' : 'success'} alert-dismissible fade show m-3`} role="alert">
                                {alertModal.message}
                                <button type="button" className="close" onClick={() => setAlertModal({ message: '', type: '' })}>
                                    <span>&times;</span>
                                </button>
                            </div>
                        )}

                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre de la spécialité <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={nouvSpecialite.titre}
                                        onChange={(event) => {
                                            setNouvSpecialite({
                                                ...nouvSpecialite,
                                                titre: event.target.value,
                                            });
                                        }}
                                        placeholder="Ex: Développement Web, Data Science, etc."
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tags</Form.Label>
                                    <Select
                                        isMulti
                                        options={tagOptions}
                                        value={tagOptions.filter(option =>
                                            nouvSpecialite.tag.includes(option.value)
                                        )}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                            setNouvSpecialite({
                                                ...nouvSpecialite,
                                                tag: selectedValues
                                            });
                                        }}
                                        placeholder="Sélectionnez des tags..."
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '38px',
                                                borderColor: '#e5e6e7',
                                                '&:hover': {
                                                    borderColor: '#0d6efd'
                                                }
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#0d6efd',
                                                color: 'white'
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: 'white'
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: 'white',
                                                '&:hover': {
                                                    backgroundColor: '#0d6efd',
                                                    color: 'white'
                                                }
                                            })
                                        }}
                                    />
                                    <small className="text-muted">Vous pouvez sélectionner plusieurs tags</small>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseAddModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleEnregSpecialite}>
                                Enregistrer
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de modification avec react-select */}
                    <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
                        <Modal.Header>
                            <Modal.Title>Modifier la spécialité</Modal.Title>
                        </Modal.Header>

                        {alertModal.message && (
                            <div className={`alert alert-${alertModal.type === 'danger' ? 'danger' : 'success'} alert-dismissible fade show m-3`} role="alert">
                                {alertModal.message}
                                <button type="button" className="close" onClick={() => setAlertModal({ message: '', type: '' })}>
                                    <span>&times;</span>
                                </button>
                            </div>
                        )}

                        <Modal.Body>
                            <Form onSubmit={handleModifierSpecialite}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre de la spécialité <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={specialiteToEdit?.titre || ''}
                                        onChange={(event) => {
                                            setSpecialiteToEdit({
                                                ...specialiteToEdit,
                                                titre: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tags</Form.Label>
                                    <Select
                                        isMulti
                                        options={tagOptions}
                                        value={tagOptions.filter(option =>
                                            specialiteToEdit?.tag && specialiteToEdit.tag.includes(option.value)
                                        )}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                            setSpecialiteToEdit({
                                                ...specialiteToEdit,
                                                tag: selectedValues
                                            });
                                        }}
                                        placeholder="Sélectionnez des tags..."
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '38px',
                                                borderColor: '#e5e6e7',
                                                '&:hover': {
                                                    borderColor: '#0d6efd'
                                                }
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: '#0d6efd',
                                                color: 'white'
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: 'white'
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: 'white',
                                                '&:hover': {
                                                    backgroundColor: '#0d6efd',
                                                    color: 'white'
                                                }
                                            })
                                        }}
                                    />
                                    <small className="text-muted">Vous pouvez sélectionner plusieurs tags</small>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseEditModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleModifierSpecialite}>
                                {isLoading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    'Enregistrer'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal de suppression */}
                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>

                        {alertModal.message && (
                            <div className={`alert alert-${alertModal.type === 'danger' ? 'danger' : 'success'} alert-dismissible fade show m-3`} role="alert">
                                {alertModal.message}
                                <button type="button" className="close" onClick={() => setAlertModal({ message: '', type: '' })}>
                                    <span>&times;</span>
                                </button>
                            </div>
                        )}
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer la spécialité : <strong>{specialiteToDelete?.titre}</strong> ?
                            <br />
                            <small className="text-danger">Cette action est irréversible.</small>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="danger" onClick={handleDeleteSpecialite}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Liste_Specialite;